import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserSimpleGoal } from '@app/leaderboard/model/user.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-leaderboard-item-goal',
    templateUrl: './goal.component.html',
    styleUrls: ['./goal.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LeaderboardItemGoalComponent {
    /**
     * Leaderboard User
     */
    @Input()
    user!: UserSimpleGoal;

    private translateService = inject(TranslateService);

    getTrendColor(trend: string) {
        switch (trend) {
            case 'success':
                return 'primary';
            case 'muted':
                return 'black';
            case 'muted-2':
                return 'black-10';
            case 'danger':
                return 'danger';
        }
    }

    get userFullName() {
        if (this.user.me) {
            return this.translateService.instant('v3-globale-me');
        }
        return `${this.user.firstname} ${this.user.surname}`;
    }
}
